import { render, staticRenderFns } from "./NewChecklistChooseTemplatePage.vue?vue&type=template&id=ad3c8e68&"
import script from "./NewChecklistChooseTemplatePage.vue?vue&type=script&lang=ts&"
export * from "./NewChecklistChooseTemplatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports